import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Box = styled.div`
	position: relative;
	border-radius: 16px;
	//background: rgba(0, 0, 0, 0.6);
	//box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.25);
	box-sizing: border-box;
	width: fit-content;
	padding: 0.37em;
	height: 3.3em;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 0.8em;
`;

export const Button = styled(ThemeButton)`
	padding: 0.2em;
	width: 6em;
	height: 100%;
	font-size: 1.1em;
	border-radius: 12px;
`;
